import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import styled from "styled-components";
import * as Sentry from "@sentry/react";

const ErrorDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const ErrorMessage = styled.p`
  padding-bottom: 10;
`;

export const SlackOAuthErrorScreen: React.FC<RouteComponentProps> = () => {
  const history = useHistory();
  const [deploymentId, setDeploymentId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const urlParams: URLSearchParams = new URLSearchParams(
      history.location.search
    );
    const depId = urlParams.get("deployment_id");
    const qsError = urlParams.get("error");
    setDeploymentId(depId);
    setError(qsError);
    Sentry.captureMessage(
      `Semgrep Slack app: Deployment with id '${depId}' encountered error during OAuth. Description: '${qsError}'`
    );
  }, [history.location.search]);

  return (
    <ErrorDiv>
      <h1>Semgrep Slack app OAuth Error</h1>
      Semgrep encountered an error during installation of the Semgrep Slack app.{" "}
      <strong>
        <code>{error}</code>
      </strong>
      <ErrorMessage>
        Please email support@r2c.dev and let us know so we can fix it!
      </ErrorMessage>
      <h2>Deployment Id</h2>
      <pre>{deploymentId}</pre>
      <h2>Description</h2>
      <pre>{error}</pre>
    </ErrorDiv>
  );
};
